import { useState, useEffect } from "react";

const MOBILE_QUERY = "(max-width: 767px)";

// Read synchronously on first call so the initial render is correct.
// Avoids the flash where desktop briefly shows the mobile component (or vice versa)
// because the old hook initialised `matches` as `false` before useEffect fired.
function getIsMobile() {
    if (typeof window === "undefined") return false; // SSR safe
    return window.matchMedia(MOBILE_QUERY).matches;
}

export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(getIsMobile);

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_QUERY);
        const handler = (e) => setIsMobile(e.matches);
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);

    return isMobile;
}
